export default __webpack_public_path__ + "static/media/holytrinity.72a54ec9.jpg";